module.exports = __webpack_public_path__ + "img/person.b534c2fd.png";